/* eslint-disable no-use-before-define */
import React from 'react'
import { useOrderTicket } from '../../use-order-ticket'
import { arrayFrom, fmt, showModal, parseHtml, Loading } from '../../../twd'


export let OpenOrders = () => {
    const { openOrders, openOrdersStatus, openOrdersCount } = useOrderTicket()

    const [selected, setSelected] = React.useState(null)

    return <React.Fragment>
        <Loading status={openOrdersStatus}>
        <div className="row vertical-offset-xs"></div>

        {openOrdersCount===0 && <React.Fragment>
            <div className="row text-center vertical-offset-xs">
                <div className="vertical-offset-xs">
                <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
                </div>
                <div className="vertical-offset-xs">
                <div className="small-header vertical-offset-xxs">There are no open orders in this account.</div>
                </div>
            </div>
        </React.Fragment>}

        {openOrdersCount > 0 && <React.Fragment>
            <div className="row vertical-offset-xs">
            <div className="col-md-12 col-xs-12">
                Select an open order to view or request cancellation.
            </div>
            </div>

            <div className="row vertical-offset-sm">
            <div className="col-md-12 col-xs-12 table-responsive"
                style={{display:"block", maxHeight:"450px",}}>
                <Grid {...{openOrders, setSelected}} />
            </div>
            </div>

            <div className="row vertical-offset-xs">
            <div className="col-md-12 col-xs-12">
                Showing all open orders for the active account.
            </div>
            </div>

            <div className="row">
            <div className="col-md-12 col-xs-12">
                <Buttons {...{selected}} />
            </div>
            </div>
        </React.Fragment>}

        </Loading>
    </React.Fragment>
}

const Grid = ({openOrders, setSelected}) => {

    return <React.Fragment>
        <table
            className="table align-top">
        <thead>
            <tr>
            <th className="col-md-1">&nbsp;</th>
            <th className="col-md-5">Issuer/CUSIP</th>
            <th className="col-md-1">Action</th>
            <th className="col-md-1 text-right">Qty</th>
            <th className="col-md-2 text-right">Exec Price</th>
            <th className="col-md-2 text-right"  style={{whiteSpace:"nowrap"}}>Est Total Cost</th>
            </tr>
        </thead>
        <tbody>
        { arrayFrom(openOrders)
            .map(({
                tradeNum, tradeActions,
                holdIssue, holdCusip,
                tradeType, tradeQtyBond, tradeFilledPx,
                propTransNetMoney, propTransNetMoneyStr
            },i) => {

                const [el, setEl] = React.useState(null)
                const isAuction = String(propTransNetMoneyStr).toLowerCase() === 'auction'

                return <tr key={i}>
                    <td>
                        <input
                            ref={setEl}
                            type="radio"
                            name="order-ticket-open-orders-select"
                            value={{tradeNum, tradeActions,}}
                            onChange={() => { setSelected({tradeNum, tradeActions,})}}
                        />
                    </td>
                    <td style={{maxWidth:'200px'}}>
                        <button
                        className="link-button text-truncate text-left"
                        style={{ width:'100%' }}
                        onClick={() => {
                            if (!el) return
                            el.checked = true
                            setSelected({tradeNum, tradeActions,})
                        }}
                        >{parseHtml(holdIssue)}</button>
                        <br/>
                        {holdCusip.join('')}
                    </td>
                    <td style={{whiteSpace:"nowrap"}}>{formatTradeType(tradeType[0])}</td>
                    <td className="text-right">{fmt.qty(tradeQtyBond)}</td>
                    <td className="text-right">{isAuction ? 'Auction' : fmt.money(tradeFilledPx)}</td>
                    <td className="text-right">{isAuction ? 'Auction' : fmt.money(propTransNetMoney)}</td>
                </tr>

            }) }
        </tbody>
        </table>
    </React.Fragment>
}

const formatTradeType = (a) =>
    a==='Offer-W' ? <span><span className="text-bold" style={{color:'#107A1B'}}>Buy Quote</span><br/><span style={{fontWeight:'400'}}>(Offer wanted)</span></span> :
    a==='Bid-W' ? <span><span className="text-bold" style={{color:'#CC0000'}}>Sell Quote</span><br/><span style={{fontWeight:'400'}}>(Bid wanted)</span></span> :
    a==='Buy' ? <span className="text-bold" style={{color:'#107A1B'}}>Buy</span> :
    a==='Sell' ? <span className="text-bold" style={{color:'#CC0000'}}>Sell</span> :
    null

const Buttons = ({selected}) => {
    return <React.Fragment>
        <button
            disabled={!selected}
            aria-disabled={!selected}
            className="btn btn-primary-outline"
            onClick={(e) => {
                showModal({
                    view: 'order-detail',
                    action: 'view',
                    orderNo:selected.tradeNum,
                    source: e.target,
                })
            }}>View</button>
        <span aria-hidden={true} style={{padding:'0 0 0 10px'}}></span>
        <button
            disabled={!selected || selected.tradeActions.split(',').indexOf('cancel')<0 }
            aria-disabled={!selected || selected.tradeActions.split(',').indexOf('cancel')<0}
            className="btn btn-primary-outline"
            onClick={(e) => {
                showModal({
                    view: 'order-detail',
                    action: 'cancel',
                    orderNo:selected.tradeNum,
                    source: e.target,
                })
            }}>Request to Cancel</button>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/order-ticket/snapshot/open-orders/open-orders.js